import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
// import {ProjectThumbnail} from 'src/app/models/project-thumbnail';
import { InspectionThumbnail } from 'src/app/models/inspection-thumbnail';

/** Componente del slider la galería */
@Component({
  selector: 'app-gallery-slider',
  templateUrl: './gallery-slider.component.html',
  styleUrls: ['./gallery-slider.component.scss']
})
export class GallerySliderComponent {

  /** Comprobar si se hace click */
  isClickItem = false;

  /** Porcentaje del ancho */
  @Input() widthPercent = 30;
  /** Altura */
  @Input() height = 278;
  /** Márgen derecho */
  @Input() marginRight = 30;
  /** Obtiene thumbnails de las imágenes */
  @Input() images: InspectionThumbnail[] = [];

  /** Emite evento al filtar */
  @Output() filterChange = new EventEmitter<string>();

  /**
   * Constructor
   * @ignore
   */
  constructor(private router: Router) { }

  /**
   * Te lleva a la página de la inspección
   * @param inspectionId
   */
  onSliderClick(inspectionId: number) {
    if (this.isClickItem) {
      this.router.navigateByUrl(`inspections/${inspectionId}`);
    }
  }

  /**
   * Revisa si haces click en el slider
   * @param isClick
   */
  clickItem(isClick: boolean) {
    this.isClickItem = isClick;
  }
}
